import api from "@/api/checkout";
import FormValidator from "@/services/FormValidator";

export default {
  namespaced: true,
  state: {
    currentStep: 'delivery',
    steps: ['delivery', 'payment', 'final'],
    availableDeliveries: [],
    availablePaySystems: [],
    orderSummary: {},
    model: {
      name: '',
      surName: '',
      email: '',
      phone: '',
      agreeSubscribe: false,
      locationCode: '',
      zip: '',
      street: '',
      house: '',
      building: '',
      apartments: '',
      deliveryId: '',
      paysystemId: '',
      comment: '',
    },
    orderSaveResult: {},
    orderSaveErrors: [],
    errors: {}
  },
  getters: {
    currentStep(state) {
      return state.currentStep;
    },
    haveErrors(state) {
      return Object.keys(state.errors).length !== 0;
    },
    isOrderSaved(state) {
      return !!state.orderSaveResult.orderId;
    }
  },
  mutations: {
    nextStep(state) {
      let currentStepIdx = state.steps.indexOf(state.currentStep);

      currentStepIdx++;
      if (currentStepIdx > state.steps.length) {
        currentStepIdx = 0;
      }

      const stepName = state.steps[currentStepIdx];

      if (!FormValidator.validate(state, stepName)) {
        return false;
      }

      state.currentStep = stepName;
    },
    setStep(state, stepName) {
      if (!FormValidator.validate(state, stepName)) {
        return false;
      }

      let stepIdx = state.steps.indexOf(stepName);

      if (stepIdx === -1) {
        throw 'Invalid step name';
      }

      state.currentStep = stepName;
    },
    setAvailableDeliveries(state, deliveries) {
      state.availableDeliveries = deliveries;
    },
    setAvailablePaySystems(state, paySystems) {
      state.availablePaySystems = paySystems;
    },
    setOrderSummary(state, summary) {
      state.orderSummary = summary;
    },
    setOrderSaveResult(state, result) {
      state.orderSaveResult = result;
      state.orderSaveErrors = [];
    },
    setOrderSaveErrors(state, errors) {
      let errorsFormatted = {};
      errors.forEach((error, idx) => errorsFormatted[idx] = error.title);
      state.errors = errorsFormatted;
    }
  },
  actions: {
    nextStep({ commit }) {
      commit('nextStep');
    },
    setStep({ commit }, step) {
      commit('setStep', step);
    },
    async loadAvailableDeliveries({ commit }, params) {

      commit('setLoadingFlags', { name: 'loadAvailableDeliveries', bool: true }, { root: true });

      await api.loadAvailableDeliveries(params, (responseData) => {
        commit('setAvailableDeliveries', responseData.data);
      },
        err => window.console.log(err)
      );

      commit('setLoadingFlags', { name: 'loadAvailableDeliveries', bool: false }, { root: true });
    },

    async loadAvailablePaySystems({ commit }, params) {

      commit('setLoadingFlags', { name: 'loadAvailablePaySystems', bool: true }, { root: true });

      await api.loadAvailablePaySystems(params, (responseData) => {
        commit('setAvailablePaySystems', responseData.data);
      },
        err => window.console.log(err)
      );

      commit('setLoadingFlags', { name: 'loadAvailablePaySystems', bool: false }, { root: true });
    },

    async loadOrderSummary({ commit }, params) {

      commit('setLoadingFlags', { name: 'loadOrderSummary', bool: true }, { root: true });

      await api.loadOrderSummary(params, (responseData) => {
        commit('setOrderSummary', responseData.data);
      },
        err => window.console.log(err)
      );

      commit('setLoadingFlags', { name: 'loadOrderSummary', bool: false }, { root: true });
    },

    async saveOrder({ commit }, params) {

      commit('setLoadingFlags', { name: 'saveOrder', bool: true }, { root: true });

      await api.saveOrder(params, (responseData) => {
        console.log(responseData);
        //responseData = JSON.parse(responseData.replace('individual', ''));
        if (responseData.success !== true) {
          commit('setOrderSaveErrors', responseData.errors);
        } else {
          commit('setOrderSaveResult', responseData.data);
        }
      },
        err => window.console.log(err)
      );

      commit('setLoadingFlags', { name: 'saveOrder', bool: false }, { root: true });
    }
  }
}
